import {BrokenRule} from './broken-rule';
import {AuditableResult} from './auditable-result';
import {RestrictedIata} from "./restricted-iata";

export class AuditableRestrictedIata extends AuditableResult<RestrictedIata> {
  constructor(restrictedIata: RestrictedIata, brokenRules: Array<BrokenRule> = new Array<BrokenRule>()) {
    super(restrictedIata, brokenRules);
  }

  static parseRestrictedIataJson(restrictedIata: RestrictedIata) {
    return JSON.stringify({
      'restrictedIata': restrictedIata
    });
  }

  static parseRestrictedIataResponse(json: Object) {
    let success = json['wasSuccessful'];
    let brokenRules: Array<BrokenRule> = null;

    if (!success) {
      brokenRules = json["brokenRules"].map(r => Object.assign(new BrokenRule(), {
        message: r.message
      }));
      return new AuditableRestrictedIata(null, brokenRules);
    }

    let result = new RestrictedIata(
      json["restrictedIata"].id,
      json["restrictedIata"].iataNumber,
      json["restrictedIata"].isIncluded,
      json["restrictedIata"].iataPartner,
      json["restrictedIata"].createdBy,
      json["restrictedIata"].createdDate,
      json["restrictedIata"].updatedBy,
      json["restrictedIata"].updatedDate
    );

    return new AuditableRestrictedIata(result, brokenRules);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/auditable-restricted-iata.ts